



















































import { Component } from "vue-property-decorator";
import BasePage from "@/views/base/BasePage";
import { NullableString } from "@/code/Types";
import { accountStore } from "@/store/modules/AccountStore";
import { Routes } from "@/router/Routes";
import { clientsStore } from "@/store/modules/ClientStore";
import { ClientData } from "@/models/ClientData";

@Component
export default class extends BasePage {
  get allDocuments(): ClientData[] {
    return clientsStore.entities;
  }

  search: NullableString = null;
  headers = [
    { text: "Client Name", value: "clientFullName" },
    { text: "Age", value: "clientAge" },
    { text: "Date of Birth", value: "clientDateOfBirth" },
    { text: "New Business​", value: "newBusinessNumber" },
    { text: "Existing Policies", value: "existingPolicies" },
  ];
  get agentFullName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }

  async selectClient(clientId: string): Promise<void> {
    await this.$router.push({
      name: Routes.CLIENT,
      params: { id: clientId },
    });
  }
}
